import momentTz from "moment-timezone";

export const getCountryTimeZone = () => {
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneAbbreviation = momentTz.tz(timeZoneName).format("z");
  return timeZoneAbbreviation;
};
